import { z } from "zod"

export const InstagramAuthorizeSchema = z.object({
  code: z.string(),
})

export const InstagramIntegrationParams = z.object({
  id: z.string().transform(BigInt),
})
